export default {
  validateDPI(dpi) {
    let dpiRegex = new RegExp('^[0-9]{4}\\s?[0-9]{5}\\s?[0-9]{4}$');
    if (!dpiRegex.test(dpi)) {
      return false;
    }

    let state = parseInt(dpi.substring(9, 11));
    let city = parseInt(dpi.substring(11, 13));
    let verifier = parseInt(dpi.substring(8, 9));
    let number = dpi.substring(0, 8);

    let citiesPerState = [
      // 01 - Guatemala cities
      17,
      // 02 - El Progreso cities
      8,
      // 03 - Sacatepáquez cities
      16,
      // 04 - Chimaltenango cities
      16,
      // 05 - Escuintla cities
      13,
      // 06 - Santa Rosa cities
      14,
      // 07 - Sololá cities
      19,
      // 08 - Totonicapán cities
      8,
      // 09 - Quetzaltenango cities
      24,
      // 10 - Suchitepéquez cities
      21,
      // 11 - Retalhuleu cities
      9,
      // 12 - San Marcos cities
      30,
      // 13 - Huehuetenango cities
      32,
      // 14 - Quiché cities
      21,
      // 15 - Baja Verapaz cities
      8,
      // 16 - Alta Verapaz cities
      17,
      // 17 - Petén cities
      14,
      // 18 - Izabal cities
      5,
      // 19 - Zacapa cities
      11,
      // 20 - Chiquimula cities
      11,
      // 21 - Jalapa cities
      7,
      // 22 - Jutiapa cities
      17
    ];

    if (!state || !city) {
      return false;
    }

    if (isNaN(verifier)) {
      return false;
    }

    if (state > citiesPerState.length) {
      return false;
    }

    if (city > citiesPerState[state - 1]) {
      return false;
    }

    let total = 0;
    for (let i = 0; i < number.length; i++) {
      let char = number[i];
      let charInt = parseInt(char);

      if (isNaN(charInt)) {
        return false;
      }

      total += charInt * (i + 2);
    }

    let mod = total % 11;
    if (mod != verifier) {
      return false;
    }

    return true;
  },
  validateNIT(nit) {
    if (!nit) {
      return true;
    }

    let allowedNit = [
      "cf", "c.f.", "c.f"
    ];
    let loweredNit = nit.toLowerCase();
    if (allowedNit.includes(loweredNit)) {
      return true;
    }

    let nitRegex = new RegExp('^[0-9]+(-?[0-9kK])?$');

    if (!nitRegex.test(nit)) {
      return false;
    }

    nit = nit.replace(/-/, '');
    

    let lastChar = nit.length - 1;
    let number = nit.substring(0, lastChar);
    let expectedCheker = nit.substring(lastChar, lastChar + 1).toLowerCase();

    let factor = number.length + 1;
    let total = 0;

    for (let i = 0; i < number.length; i++) {
      let character = number.substring(i, i + 1);
      let digit = parseInt(character, 10);

      total += (digit * factor);
      factor = factor - 1;
    }

    let mod = (11 - (total % 11)) % 11;
    let computedChecker = (mod == 10 ? "k" : mod.toString());

    return expectedCheker === computedChecker;
  }
}